<template>
  <div class='tabs'>
    <el-tabs v-model='activeName' type='card' @tab-click='handleClick'>
      <el-tab-pane v-for='item in tabArray' :key='item.name' :label='$t(item.label)' :name='item.name'></el-tab-pane>
    </el-tabs>
    <!-- 绑定了事件才会显示 -->
    <i v-if='$listeners.downLoad' class='el-icon-download icon' :title="$t('integration.export')" @click='downLoad'></i>
  </div>
</template>

<script>
export default {
  props: ['tabs'],
  data () {
    return {
      activeName: 'temp',
      tabArray: [
        {
          label: $t('integration.temperature'),
          name: 'temp'
        },
        {
          label: $t('integration.humidity'),
          name: 'hum'
        },
        // 增加气体和门磁tab
        {
          label: $t('integration.gas'),
          name: 'gas'
        },
        {
          label: $t('integration.coz'),
          name: 'coz'
        },
        {
          label: $t('integration.magnetism'),
          name: 'magnetism'
        },
        // 
        {
          label: $t('integration.voltage'),
          name: 'volt'
        },
        {
          label: 'RSSI',
          name: 'rssi'
        },
        {
          label: 'LQI',
          name: 'lqi'
        }
      ]
    }
  },
  watch: {
    tabs: {
      handler () {
        if (this.tabs) {
          this.filterTab(this.tabs)
        }
      },
      immediate: true
    }
  },
  methods: {
    handleClick (row) {
      const { name } = row
      this.$emit('unitChange', name)
    },
    downLoad () {
      this.$emit('downLoad')
    },
    filterTab (include = []) {
      this.tabArray = this.tabArray.filter(item => {
        if (include.findIndex(includeItem => includeItem === item.name) !== -1) {
          return true
        } else {
          return false
        }
      })
    }
  },
  mounted () {
    const { probe } = this.$route.query
    if (probe) {
      this.activeName = probe
    }
  }
}
</script>

<style lang='scss' scoped>
.tabs {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .icon {
    cursor: pointer;

    &:hover {
      font-weight: bold;
    }
  }
}
</style>
